<template lang="pug">
#transaction-history.tab-pane.fade.show.active
  .statement-wrapper
    .statement-mobile
      .statement-single
        template(v-if="transactionHistory.length > 0")
          .statement-single-content(v-for="(ticket, index) in transactionHistory")
            .statement-date {{ticket.request_type}}
            //- .statement-date(v-if="ticket.deposit_date") {{$moment(ticket.deposit_date).format("YYYY-MM-DD HH:mm:ss")}} {{ticket.request_type}}
            //- .statement-date(v-else) {{$moment(ticket.created_date).format("YYYY-MM-DD HH:mm:ss")}}
            .statement-detail
              .statement-detail-left {{$t('ui.date')}}
              .statement-detail-right(v-if="ticket.deposit_date") {{$moment(ticket.deposit_date).format("YYYY-MM-DD HH:mm:ss")}} {{ticket.request_type}}
              .statement-detail-right(v-else) {{$moment(ticket.created_date).format("YYYY-MM-DD HH:mm:ss")}}
            .statement-detail
              .statement-detail-left {{$t('ui.method')}}
              .statement-detail-right {{ticket.target_bank_id}}({{ticket.deposit_method}})
            .statement-detail
              .statement-detail-left {{$t('ui.amount')}}
              .statement-detail-right(v-if="ticket.deposit_method==='USDT'") {{ticket.amount}}
                span.text-warning ({{ ticket.exchanged_amount }} USDT)
              .statement-detail-right(v-else) {{ticket.amount}}
            .statement-detail
              .statement-detail-left {{$t('ui.status')}}
              .statement-detail-right(:class="getColor(ticket.status, ticket.request_type)") {{getStatus(ticket.status, ticket.request_type)}} 
        template(v-else)
          .text-center.py-2 {{ $t('ui.no_record') }}!
    .statement-desktop
      .table-statement
        .row.table-statement-row
          .col.table-statement-col {{$t('ui.no')}}
          .col.table-statement-col {{$t('ui.date')}}
          .col.table-statement-col {{$t('ui.type')}}
          .col.table-statement-col {{$t('ui.method')}}
          .col.table-statement-col {{$t('ui.bank')}}
          .col.table-statement-col {{$t('ui.amount')}}
          .col.table-statement-col {{$t('ui.status')}}
          .col.table-statement-col {{$t('ui.eta')}}
        template(v-if="transactionHistory.length > 0")
          .row.table-statement-row(v-for="(ticket, index) in transactionHistory")
            .col.table-statement-col {{index+1}}
            .col.table-statement-col {{$moment(ticket.created_date).format("YYYY-MM-DD HH:mm:ss")}}
            .col.table-statement-col {{ticket.request_type}}
            .col.table-statement-col(v-if="ticket.deposit_method != null ") {{ticket.deposit_method}}
            .col.table-statement-col(v-else) -
            .col.table-statement-col {{ticket.target_bank_id}}
            .col.table-statement-col(v-if="ticket.deposit_method==='USDT'") {{ticket.amount}} 
              span.text-warning ({{ ticket.exchanged_amount }} USDT)
            .col.table-statement-col(v-else) {{ticket.amount}}
            .col.table-statement-col(:class="getColor(ticket.status, ticket.request_type)") {{getStatus(ticket.status, ticket.request_type)}} 
            .col.table-statement-col {{$moment(ticket.created_date).add(5, "m").format("YYYY-MM-DD HH:mm:ss")}}
        template(v-else)
          .text-center.py-2 {{ $t('ui.no_record') }}!
</template>
<script>
export default {
  data() {
    return {
      // lastUpdateTime: new Date(),
      transactionHistory: [],
      refreshTicket: null
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
  mounted(){
    window.scroll(0,0)
    var vm = this
    this.getMemberTicketList()
    this.refreshTicket = setInterval(() => {
      vm.getMemberTicketList()
    }, 10000)
  },
  beforeDestroy: function() {
    clearInterval(this.refreshTicket)
  },
  methods:{
    clearIntervalLoop(){
      clearInterval(this.refreshTicket);
    },
    getStatus(status, request) {
      var tag = "ui.unknown";
      switch(status) {
        case "REJECTED":
          tag = "ui.failed";
          break;
        case "pending":
          tag = "ui.pending";
          break;
        case "PROCESSED":
          tag = "ui.approved";
          break;
      }
      if(status==="PROCESSING"){
        return this.$t('ui.pending') + "(" + this.$t('ui.payment_gateway') + ")"
      }else{
        return this.$t(tag);
      }
      
    },
    getColor(status, request) {
      var tag = "";
      switch(status) {
        case "REJECTED":
          tag = "text-danger";
          break;
        case "pending":
        case "PROCESSING":
          tag = "text-warning";
          break;
        case "PROCESSED":
          tag = "text-success";
          break;
      }
      return tag;
    },
    getMemberTicketList() {
      if (this.sessionToken) {
        // this.lastUpdateTime = new Date()
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberTicketList", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.transactionHistory = response.data;
              this.$emit("updateTrans", this.transactionHistory.length)
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }      
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }else{
              if(response.status.status == 0){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list.disconnect"), "info", this);
                this.$router.push("/").catch(error =>{})
              }
            }
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    }
  }
}
</script>